import React, {useState} from "react";
import { Button, Column, Columns, Input, Modal, Section, TextArea, Title } from "@allxsmith/bestax-bulma";
import axios from "axios";
import {useDispatch} from "react-redux";
import {createSetDataFreshAction} from "../../actions/dataActions";


export default function CreateCreditNoteModal({autoFill, endpoint, dataFresh, open, setOpen}){
    const [credit, setCredit] = useState({});
    const dispatch = useDispatch();

    const onChange = e => {
        let newCredit = {...credit, [e.target.name]: e.target.value};
        setCredit(newCredit);
    }


    const onSave = (data) => {
       if(autoFill.transaction){
           data.transaction = autoFill.transaction
       }
       else if(autoFill.invoice){
           data.invoice = autoFill.invoice
       }
       else if(autoFill.work){
           data.work = autoFill.work
       }
       else if(autoFill.part){
           data.part = autoFill.part
       }

       const conf = {
           url: endpoint + "credit",
           method: "post",
           data: data
       };
       axios(conf).then(res => {
           dispatch(createSetDataFreshAction(dataFresh + 1));
           setOpen(false);
       })
    }


    return (
        <Modal
            active={open}
            onClose={() =>{
                setCredit({})
                setOpen(false);
            }}
        >
            <Modal.Content className={"wider-modal"}>
                <Section style={{background: "white"}}>
                    <Columns isMultiline>
                        <Column>
                            <Title>Create Credit Note</Title>
                        </Column>
                    </Columns>
                    <Columns isMultiline>
                        <Column>
                            <label className="label">Customer Name</label>
                            <Input
                                type={"text"}
                                value={autoFill.customer.display_name ?? autoFill.customer}
                                disabled={true}
                            />
                        </Column>
                        <Column>
                            <label className="label">Amount (£)</label>
                            <Input
                                name={"amount"}
                                type={"number"}
                                value={credit.amount}
                                onChange={onChange}
                            />
                        </Column>
                        <Column>
                            <label className="label">Non Vat Amount (£)</label>
                            <Input
                                name={"no_vat_amount"}
                                type={"number"}
                                value={credit.no_vat_amount}
                                onChange={onChange}
                            />
                        </Column>
                        <Column>
                            <label className="label">Date Issued</label>
                            <Input
                                name={"date_issued"}
                                type={"date"}
                                value={credit.date}
                                onChange={onChange}
                            />
                        </Column>
                        <Column>
                            <label className="label">Credit Note Number</label>
                            <Input
                                type={"text"}
                                name={"credit_note_number"}
                                onChange={onChange}
                                value={credit.credit_note_number}
                            />
                        </Column>
                        <Column>
                            <label className="label">Description</label>
                            <TextArea
                                name={"description"}
                                value={credit.description}
                                onChange={onChange}
                            />
                        </Column>
                    </Columns>
                    <Columns isMultiline>
                        <Column>
                            <Button
                                onClick={() => {
                                    onSave(credit);
                                }}
                                color={"success"}
                                isFullWidth
                            >
                                Create
                            </Button>
                        </Column>
                        <Column>
                            <Button
                                color={"info"}
                                onClick={()=> {
                                    setCredit({});
                                    setOpen(false);
                                }}
                                isFullWidth
                            >
                                Cancel
                            </Button>
                        </Column>
                    </Columns>
                </Section>
            </Modal.Content>
        </Modal>
    );



}